export const FrogFace = ({ size = 48, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden="true">
    {/* Eyes */}
    <circle cx="30" cy="28" r="16" fill="#22C55E" />
    <circle cx="70" cy="28" r="16" fill="#22C55E" />
    <circle cx="30" cy="26" r="9" fill="#fff" />
    <circle cx="70" cy="26" r="9" fill="#fff" />
    <circle cx="30" cy="27" r="4.5" fill="#1E293B" />
    <circle cx="70" cy="27" r="4.5" fill="#1E293B" />
    {/* Body */}
    <ellipse cx="50" cy="60" rx="38" ry="32" fill="#22C55E" />
    <ellipse cx="50" cy="72" rx="26" ry="16" fill="#86EFAC" />
    {/* Rosy cheeks */}
    <circle cx="22" cy="60" r="5" fill="#F87171" opacity="0.75" />
    <circle cx="78" cy="60" r="5" fill="#F87171" opacity="0.75" />
    {/* Smile */}
    <path d="M32 62 Q50 76 68 62" stroke="#1E293B" strokeWidth="3.5" fill="none" strokeLinecap="round" />
  </svg>
);

export const LilyPad = ({ size = 48, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden="true">
    <ellipse cx="50" cy="52" rx="44" ry="34" fill="#4ADE80" />
    <path d="M50 52 L92 36 A44 34 0 0 0 50 18 Z" fill="#86EFAC" />
    <path d="M50 52 L92 36" stroke="#16A34A" strokeWidth="2" />
  </svg>
);
